// SQUIDDI-chatbot - 2026-10-08
// Eventi di misura verso window.dataLayer (GTM/GA4 se e quando verranno
// installati). Nessuna chiamata API, nessun evento esistente toccato.
export const track = (event, props = {}) => {
  if (typeof window === "undefined") return;
  const device = window.matchMedia?.("(max-width: 767px)")?.matches ? "mobile" : "desktop";
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, device, ...props });
};

export default track;
